export const Permissions = {
  EnableBilling: "EnableBilling",
  EnableOrdering: "EnableOrdering",
  SAVRCustomerProgram: "SAVRCustomerProgram",
  TripsCustomerProgram: "TripsCustomerProgram",
  EnableOrderHistory: "EnableOrderHistory",
  EnableProductBrowsing: "EnableProductBrowsing",
  ProZoneCustomerProgram: "ProZoneCustomerProgram",
  JobsAndMaterialList: "JobsAndMaterialList",
  ProBucksCustomerProgram: "ProBucksCustomerProgram",
  LansingNEView: "LansingNEView",
  LegacyLansingView: "LegacyLansingView",
  SelectBranch: "SelectBranch",
  BillTrust: "BillTrust",
  CheckNearbyStore: "CheckNearbyStore",
  ManagePublicJobLists: "ManagePublicJobLists",
  PublicStoreQuotes: "PublicStoreQuotes",
  PublicOrderHistoryReorder: "PublicOrderHistoryReorder",
  InternalUsersSelectBranch: "InternalUsersSelectBranch",
  ManageUsers: "ManageUsers",
  ExclusiveCustomer: "ExclusiveCustomer",
  EnableShoppingCart: "EnableShoppingCart",
};

export const MenuItems = {
  CustomerPrograms: "IMPACT Programs",
  LeadGeneration: "Lead Generation",
  ImpactRewards: "Impact Rewards",
  LoyaltyLink: "Loyalty Link",
  MarketingServices: "Marketing Services",
  FinancingSolutions: "Financing Solutions",
  TemplatesEstimates: "Templates & Estimates",
  Templates: "Templates",
  HomeownerEstimates: "Homeowner Estimates",
  MyOrdersQuotes: "My Orders & Quotes",
  Help: "Help",
  ContactUs: "Contact us",
  FAQ: "FAQ",
  Orders: "Orders",
  OpenQuotes: "Open Quotes",
  MyMostPurchased: "My Most Purchased",
  HoverMaterialListQuote: "Hover Material List Quote",
};

export const BuilderIOSections = {
  FigmaSection: "figma-section",
  FeatureZoneSection: "feature-zone-carousel",
  TagFilterName: "data.tag",
  FeaturedCategoriesFilterValue: "featuredcategories2",
  FeatureZoneFilterValue: "featurezone",
  // Global
  StorefrontFooter: "storefront-footer",
  // PGP
  PGPProductBox: "pgp-product-box",
  PGPHeader: "pgp-header",
  PGPFooter: "pgp-footer",
  // PDP
  PDPHeader: "pdp-header",
  PDPProductName: "pdp-product-name",
  PDPProductAvailability: "pdp-product-availability",
  PDPProductMainDetails: "pdp-product-main-details",
  PDPProductAboutSection: "pdp-product-about-section",
  PDPProductSpecificationSection: "pdp-product-specification-section",
  PDPProductDocumentSection: "pdp-product-document-section",
  PDPRequestQuote: 'pdp-request-quote',
  // Cart
  CartHeader: "cart-header",
  EmptyCart: "empty-cart",
  // Product Recommender
  RecommendedProductBox: 'recommended-product-box',
};

export const ErpSource = {
  SAP: "sap",
  Infor: "infor",
};

/**
 * SKUs of EagleView products.
 * Add new EagleView SKUs here as they are onboarded.
 */
export const EagleViewSkus: string[] = ["EAGLEVIEWWALL", "EAGLEVIEWROOF", "PREM PVC 2-PC SPLIT", "PREM PVC 2-PC SPLIT-BASE"];

export const isEagleViewProduct = (
  sku: string | null | undefined
): boolean => {
  if (!sku) return false;
  return EagleViewSkus.includes(sku);
};
